import { Scale } from "@/animations/scale";
import Image from "@/components/Image";
import { cn } from "@/utils";
import { formatNumber } from "@/utils/number-format";
import { useResize } from "@/utils/useResize";
import { cva } from "class-variance-authority";
import clsx from "clsx";
import { useMemo } from "react";
import Marquee from "react-fast-marquee";
import { Link } from "react-router-dom";
import { HeaderFinder } from "./header-finder";
import { WrapperFinder } from "./wrapper-finder";
import { useMiniApp } from "../apis/miniapp";
import { LIST_TOKEN } from "./data";

const variants = cva("w-full", {
  variants: {
    twSize: {
      xs: "max-w-[80%] mr-[14px] mt-[32px]",
      sm: "max-w-[80%] mr-[14px] mt-[32px]",
      md: "max-w-[80%] mr-[14px] mt-[32px]",
      lg: "max-w-[555px] mr-[32px] mt-[32px]",
      xl: "max-w-[350px] mr-[85px] -mt-[126px]",
      "2xl": "max-w-[372px] mr-[90px] -mt-[134px]",
      "3xl": "max-w-[394px] mr-[96px] -mt-[142px]",
    },
  },
  defaultVariants: {
    twSize: "2xl",
  },
});

export function FinderDapp() {
  const { twSize } = useResize();

  const { data } = useMiniApp();

  const total_actions = useMemo(() => {
    const value = data?.data?.total_actions;
    if (!value) {
      return "--";
    }

    const temp = formatNumber(Number(value));
    return `${temp.value}${temp.text ? temp.text + "+" : ""}`;
  }, [data?.data]);

  const total_users = useMemo(() => {
    const value = data?.data?.total_users;
    if (!value) {
      return "--";
    }
    const temp = formatNumber(Number(value));
    return `${temp.value}${temp.text ? temp.text + "+" : ""}`;
  }, [data?.data]);

  return (
    <Scale>
      <div className="flex flex-row w-full justify-end">
        <WrapperFinder className={cn(variants({ twSize: twSize }))}>
          <HeaderFinder>
            <p className="text-[#23262F] text-center text-[13px] font-medium leading-4 truncate">
              Holdstation dApps
            </p>
          </HeaderFinder>

          <div className="p-4 lg:p-5">
            {/* <p className="text-sm font-medium text-[#777E90] mb-2">Ranked 7th Top Dapps</p> */}
            <p className="text-2xl text-[#141416] font-medium mb-2.5">
              Holdstation Mini Dapp On Worldchain{" "}
            </p>

            <div className="grid grid-cols-2 gap-2.5">
              <div className="flex flex-col gap-2">
                <p className="text-sm font-medium text-[#777E90]">
                  Impressions
                </p>
                <p className="text-2xl text-[#141416] font-medium">
                  {total_actions}
                </p>
              </div>

              <div className="flex flex-col gap-2">
                <p className="text-sm font-medium text-[#777E90]">Users</p>
                <p className="text-2xl text-[#141416] font-medium">
                  {total_users}
                </p>
              </div>
            </div>
          </div>

          <div className="py-8 bg-[#F4F5F6] flex flex-col gap-2.5 lg:gap-4 hidden">
            <Marquee className="flex items-center gap-6">
              <div className="flex gap-4 items-center flex-shrink-0 min-w-full">
                {LIST_TOKEN.map((item, index) => (
                  <div
                    key={`${item.id}-${item.image}`}
                    className="flex-shrink-0 rounded-2xl w-10 lg:w-16 h-10 lg:h-16 overflow-hidden"
                  >
                    <Image
                      width={64}
                      height={64}
                      src={item.image}
                      alt={`Image ${index}`}
                      className="w-full h-full object-contain"
                    />
                  </div>
                ))}
              </div>
            </Marquee>

            <Marquee direction="right" className="flex items-center gap-6">
              <div className="flex gap-4 items-center flex-shrink-0 min-w-full">
                {LIST_TOKEN.map((item, index) => (
                  <div
                    key={`${item.id}-${item.image}`}
                    className="flex-shrink-0 rounded-2xl w-10 lg:w-16 h-10 lg:h-16 overflow-hidden"
                  >
                    <Image
                      width={64}
                      height={64}
                      src={item.image}
                      alt={`Image ${index}`}
                      className="w-full h-full object-contain"
                    />
                  </div>
                ))}
              </div>
            </Marquee>
          </div>

          <div className="grid grid-cols-[40px_1fr_112px] lg:grid-cols-[48px_1fr_112px] gap-2.5 lg:gap-4 p-4">
            <div className="w-10 h-10 lg:w-12 lg:h-12 rounded-xl flex-shrink-0">
              <Image
                src={require("@/assets/icons/ic_holdstation.png")}
                width={96}
                height={96}
                alt="DeFutures"
              />
            </div>

            <div className="flex flex-col justify-center">
              <p className="text-sm font-medium text-[#141416] line-clamp-1">
                Holdstation dApps
              </p>
              <p className="text-sm font-medium text-[#777E90] line-clamp-1">
                Ranked 5th Top Dapps
              </p>
            </div>
            <div className="flex items-center justify-end">
              <Link
                to={
                  "https://worldcoin.org/mini-app?app_id=app_ee968e983074cb090e6f12cd75b63bb3"
                }
                target="_blank"
                data-action="redirect_mini_app"
                className={clsx(
                  "px-6 py-2.5 rounded-full bg-black",
                  "text-sm text-white font-medium whitespace-nowrap"
                )}
              >
                Explore
              </Link>
            </div>
          </div>
        </WrapperFinder>
      </div>
    </Scale>
  );
}
